document.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const nodes=[...document.querySelectorAll('.fini-reveal')];
  if(reduce||!('IntersectionObserver'in window)){nodes.forEach(n=>n.classList.add('is-visible'));return}
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.14,rootMargin:'0px 0px -5% 0px'});
  nodes.forEach(n=>observer.observe(n));
  document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const target=document.querySelector(a.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'})}}));
  if(!reduce){
    document.querySelectorAll('[data-fini-tilt]').forEach(card=>{
      card.addEventListener('pointermove',event=>{
        const rect=card.getBoundingClientRect();
        const rx=((event.clientY-rect.top)/rect.height-.5)*-5;
        const ry=((event.clientX-rect.left)/rect.width-.5)*7;
        card.style.transform=`perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-4px)`;
      });
      card.addEventListener('pointerleave',()=>{card.style.transform=''});
    });
  }
});
